"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBanksForContext = exports.ACCOUNT_TYPES = exports.BANKS = void 0;
exports.BANKS = [
    { label: "Bank Windhoek", value: "Bank Windhoek" },
    { label: "First National Bank", value: "First National Bank" },
    { label: "Nedbank", value: "Nedbank" },
    { label: "Standard Bank", value: "Standard Bank" },
    { label: "Trutsco Bank", value: "Trutsco Bank" },
    { label: "Banco Atlantico", value: "Banco Atlantico" },
    { label: "Bank BIC Namibia", value: "Bank BIC Namibia" },
    { label: "Letshego Bank Namibia", value: "Letshego Bank Namibia" },
    { label: "NamPost Bank", value: "NamPost Bank" },
];
exports.ACCOUNT_TYPES = [
    { label: "Cheque", value: "Cheque" },
    { label: "Savings", value: "Savings" },
];
// Context-aware bank filtering
// NamPost Bank is only available for lay-buy applications
var getBanksForContext = function (context) {
    switch (context) {
        case "laybuy":
            return exports.BANKS; // All banks including NamPost
        default:
            return exports.BANKS.filter(function (bank) { return bank.value !== "NamPost Bank"; });
    }
};
exports.getBanksForContext = getBanksForContext;
